import { Navigate } from 'react-router-dom'

import { useAuth } from '@/hooks'
import { firstAppPath } from '@/utils/appHome'

import { AssetMap } from './AssetMap'
import { MapProvider } from './MapContext'
import { StatusColumnsProvider } from './StatusColumns'

/** The asset list and map. Gated on the `assetMap` grant, as its nav link is (MEGA-779). */
export const AssetMapPage: React.FC = () => {
  const { hasPermission } = useAuth()
  if (!hasPermission('assetMap')) {
    return <Navigate to={firstAppPath(hasPermission)} replace />
  }
  return (
    <MapProvider>
      <StatusColumnsProvider>
        <AssetMap />
      </StatusColumnsProvider>
    </MapProvider>
  )
}
